module.exports = __webpack_public_path__ + "img/login_banner_3.d47cd4f5.png";